import { render, staticRenderFns } from "./UserAvatarPicker.vue?vue&type=template&id=319ff659&scoped=true&"
import script from "./UserAvatarPicker.vue?vue&type=script&lang=js&"
export * from "./UserAvatarPicker.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarPicker.vue?vue&type=style&index=0&id=319ff659&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319ff659",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VFileInput,VIcon})
